let loaded = false;

export function ensureRecaptcha() {
    if (loaded) return;
    loaded = true;

    const s = document.createElement('script');
    s.src = 'https://www.google.com/recaptcha/api.js';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
}

export default ensureRecaptcha;
